import { useMemo } from "react";

import {
  Button,
  ProgressCircle,
  Tooltip,
} from "@smart/itops-sb-design-system-dom";
import { useRestoreDeletedForm } from "@smart/manage-gql-client-dom";

import { RESTORE_DELETED_FORM_TIMEOUT } from "../../types";
import { GqlDeletedForm } from "../types";

export type RestoreFormProps = {
  deletedForm: GqlDeletedForm;
};

export const RestoreForm = ({ deletedForm }: RestoreFormProps) => {
  const [restoreDeletedForm] = useRestoreDeletedForm();

  const isRestoring = useMemo(
    () =>
      deletedForm.restoredAt &&
      new Date(deletedForm.restoredAt) >
        new Date(Date.now() - RESTORE_DELETED_FORM_TIMEOUT),
    [deletedForm.restoredAt],
  );

  if (isRestoring) {
    return (
      <div
        data-testid="restore-form-button-loading"
        className="flex items-center justify-center w-[2rem] h-[2rem]"
      >
        <ProgressCircle size="xSmall" className="w-[2rem]" />
      </div>
    );
  }

  return (
    <div className="flex items-center justify-center w-[2rem] h-[2rem]">
      <Tooltip text="Restore this form" placement="top-end" offsetBy={7}>
        <Button
          data-testid="restore-form-button"
          variant="secondarySubtle"
          size="small"
          leftIcon="regularClockRotateLeft"
          onClick={() =>
            restoreDeletedForm({ variables: { uri: deletedForm.uri } }).catch(
              console.error,
            )
          }
        />
      </Tooltip>
    </div>
  );
};
